// // Relative Path: src/js/_scramble.js

// import { gsap } from "gsap";

// import { ScrambleTextPlugin } from "gsap/ScrambleTextPlugin";

// gsap.registerPlugin(ScrambleTextPlugin);

// const scrambleTexts = {
//   scramble() {
//     const allTextToScramble = document.querySelectorAll('.js-scramble');
//     allTextToScramble.forEach((el) => {
//       const textConainer = el.querySelector('.js-text-scramble__text');
//       const text = textConainer.dataset.scrambleContent;
//       const textEl = textConainer.querySelector('span').id;
//       const originalTextEl = el.querySelector('.js-scramble-text-original');
//       const originalTextId = originalTextEl.id;

//       const tl = gsap.timeline({
//         defaults: { ease: "power1.out" }
//       });

//       gsap.set(`#${originalTextId}`, {
//         opacity: 0
//       });

//       tl.to(`#${textEl}`, {
//         scrambleText: {
//           text,
//           chars: "lowerCase"
//         },
//         duration: 1
//       });

//       el.addEventListener('mouseenter', () => {
//         tl.play(0);
//       });
//     })
//   },

//   init() {
//     this.scramble();
//   }
// }

// export default scrambleTexts;


// Relative Path: src/js/_scramble.js

import { gsap } from "gsap";
import { ScrambleTextPlugin } from "gsap/ScrambleTextPlugin";

gsap.registerPlugin(ScrambleTextPlugin);

const scrambleTexts = {
  scramble() {
    // Escludiamo gli elementi che si trovano dentro .js-header
    const allTextToScramble = document.querySelectorAll('.js-scramble:not(.l-header__menu *)');

    allTextToScramble.forEach((el) => {
      const textContainer = el.querySelector('.js-text-scramble__text');
      if (!textContainer) return;

      const text = textContainer.dataset.scrambleContent;
      const textSpan = textContainer.querySelector('span');
      const originalTextEl = el.querySelector('.js-scramble-text-original');

      if (!textSpan || !text) return;

      const tl = gsap.timeline({
        paused: true,
        defaults: { ease: "power1.out" }
      });

      // Se esiste l'elemento originale, lo nascondiamo
      if (originalTextEl) {
        gsap.set(originalTextEl, { opacity: 0 });
      }

      tl.to(textSpan, {
        scrambleText: {
          text,
          chars: "lowerCase"
        },
        duration: 1
      });

      el.addEventListener('mouseenter', () => {
        tl.play(0);
      });
    });
  },

  init() {
    this.scramble();
  }
}

export default scrambleTexts;